// @ts-check
import axios from 'axios'
import qs from 'qs'
import q from 'q'

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded; charset=UTF-8'
axios.defaults.withCredentials = false

class BaseRequest {
    send({ url, type = 'get', timeout = 10000, headers = {} }, body = {}) {
        let options = {
            url,
            timeout,
            headers,
            method: type.toLocaleLowerCase()
        }
        try {
            // 处理 post 参数格式
            if (options.method === 'post') {
                options.data = qs.stringify(body)
            } else if (options.method === 'get') {
                options.params = body
            } else {
                options.data = body
            }
            return q.resolve(axios(options))
        } catch (e) {
            q.reject(e)
        }
    }
}

export default BaseRequest



// WEBPACK FOOTER //
// ./src/core/BaseRequest.js